<template>
    <div class="company-logo-slider">
        <h3 class="company-logo-slider__title" v-if="title">
            {{title}}
        </h3>
        <div 
            class="company-logo-slider__wrapper" 
            ref="wrapper" 
        >
            <template v-for="(image, index) in slides">
            <div 
                v-if="(!viewAll && index < 16) || (viewAll)" 
                :key="index"
                class="company-logo-slider__slide"
                :style="`background-image:url(${image.image})`">
            </div>
            </template>
        </div>
        <div class="company-logo-slider__button">
            <button v-if="slides && slides.length > 16" @click="showAll" class="button">{{ viewAll ? "View less" : "View all"}}</button>
        </div>
    </div>
</template>

<script>
export default {
    props: ["slides", "title"],
    data() {
        return {
            viewAll: false,
        }      
    },
    methods: {
        showAll() {
            this.viewAll = !this.viewAll;
        }
    }
}
</script>
